export default __webpack_public_path__ + "static/resource-block_measuring_sel-7371583cd1f96b3ae30afee0a5df041d.png";